import client from '../apiClient';

export async function listServiceTimes(query) {
    let response = await client.get(`/serviceTimes`, {
        params:query
    });
    return response;
}